import Icon from "@mdi/react"
import ButtonGeneric from "../../BaseComponents/Buttons/ButtonGeneric"
import { ColorPalette } from "../../../config"

export type ActionButtonType = {
  iconPath: string
  iconColor?: string
  iconSpin?: boolean
  iconStyle?: React.CSSProperties
  label: string
  title?: string
  disabled?: boolean
  count?: number
  labelStyle?: React.CSSProperties
  style?: React.CSSProperties
  onClick: () => void | Promise<void>
}

export const ActionButton = (props: ActionButtonType) => {
  const { iconPath, iconColor, iconSpin, iconStyle, label, title, count, disabled, labelStyle, style, onClick } = props

  let countBadge = null
  if (count && count > 0) {
    countBadge = <div style={styles.badge}>{count}</div>
  }

  return (
    <ButtonGeneric
      iconBefore={
        <div style={{ position: "relative" }}>
          <Icon
            style={{ width: "1.25rem", marginRight: "0.5em", ...iconStyle }}
            path={iconPath}
            spin={iconSpin}
            color={iconColor || ColorPalette.PRIMARY_BLUE}
          />
          {countBadge}
        </div>
      }
      onClick={onClick}
      label={label}
      labelStyle={{ color: ColorPalette.SECONDARY_TEXT, ...labelStyle }}
      style={{
        width: "max-content",
        fontSize: "0.8rem",
        cursor: disabled ? "not-allowed" : "pointer",
        ...style,
      }}
      title={title}
      disabled={disabled}
    />
  )
}

const styles = {
  badge: {
    position: "absolute" as "absolute",
    top: 12,
    right: 5,
    fontSize: "0.7rem",
    color: ColorPalette.PRIMARY_BLUE,
  },
}
